import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Nous utilisons des cookies',
    description:
      'Nous utilisons des cookies et des technologies similaires pour faire fonctionner cette expérience. Les cookies strictement nécessaires sont toujours actifs.',
    allow_label: 'Accepter tous les cookies',
    reject_label: 'Uniquement les strictement nécessaires',
    settings_label: 'Paramètres des cookies',
    policy_link_label: 'Politique de confidentialité et de cookies',
    categories_label: 'Catégories',
    always_on_label: 'Toujours actifs',
    required_label: 'Obligatoires',
    save_preferences_label: 'Enregistrer les préférences',
    close_label: 'Fermer',
    allow_all_optional_categories_label: 'Autoriser toutes les catégories facultatives',
    settings_title: 'Paramètres des cookies',
    settings_description:
      'Nous utilisons des cookies et des technologies similaires pour faire fonctionner cette expérience. Les cookies strictement nécessaires sont toujours actifs.',
    save_error: 'Impossible d’enregistrer votre choix de confidentialité. Veuillez réessayer.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strictement nécessaires',
      purpose: 'Nécessaires au fonctionnement de cette expérience et ne peuvent pas être désactivés.'
    },
    analytics: {
      name: 'Analytique',
      purpose: 'Mesure l’utilisation de cette expérience afin d’en améliorer les performances.'
    },
    marketing: {
      name: 'Marketing',
      purpose: 'Prend en charge la publicité et le marketing choisis par l’organisateur.'
    }
  }
};

export default locale;
